module.exports = __webpack_public_path__ + "img/ccj.e1a5a2f8.png";